import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '@quorum/api';
import { Vehicle } from '@quorum/models/xs-resource';
import { VehicleQueryParameters } from '@quorum/models/xs-query';
import { Router } from '@angular/router';

@Component({
  selector: 'svc-license-plate-scanner',
  templateUrl: './license-plate-scanner.component.html',
  styleUrls: ['./license-plate-scanner.component.scss']
})
export class LicensePlateScannerComponent implements OnInit, OnDestroy {
  @ViewChild('videoPlayer') videoplayer: ElementRef;
  @ViewChild('imageCanvas') imageCanvas: ElementRef;
  displaySearchResults: boolean = false;
  searchResults: Vehicle[];
  track: any;
  searching: boolean = false;
  constructor(private httpClient: HttpClient, private apiService: ApiService, private router: Router) {}

  ngOnInit() {
    const constraints = { video: { facingMode: 'environment' }, audio: false };
    let self = this;
    navigator.mediaDevices.getUserMedia(constraints).then(stream => {
      this.track = stream.getTracks()[0];
      const video: HTMLVideoElement = this.videoplayer.nativeElement;
      video.srcObject = stream;

      //self.videoPlayer.nativeElement.srcObject = stream;
      //self.cameraView.srcObject = stream;
    });
  }

  ngOnDestroy() {
    this.track.stop();
  }

  captureImage() {
    this.searching = true;
    this.displaySearchResults = true;

    let canvas: HTMLCanvasElement = this.imageCanvas.nativeElement;
    const video: HTMLVideoElement = this.videoplayer.nativeElement;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d').drawImage(video, 0, 0);
    let imgUrl: string = canvas.toDataURL();

    this.httpClient
      .post(`https://n86904ob12.execute-api.us-east-1.amazonaws.com/dev/image-test`, {
        image: imgUrl.replace('data:image/png;base64,', '')
      })
      .subscribe((result: any) => {
        let params: VehicleQueryParameters = new VehicleQueryParameters();
        params.licensePlateNumber = result.input
          .split('\n')
          .join(',')
          .replace(/,\s*$/, '');

        this.apiService.get(`v/1/vehicles/vehicles`, { params: params }).subscribe(vehicles => {
          if (vehicles.length == 1) {
            this.router.navigateByUrl(`vehicle/${vehicles[0].id}`);
          } else {
            this.searchResults = vehicles;
          }
          this.searching = false;
        });
      });
    //cameraOutput.classList.add("taken");
  }
}
